import React from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from 'serviceWorker';
import Root from './views/Root';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<Root tab="home" />);

serviceWorker.unregister();
